import React from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import CourseFilter from './containers/CourseFilter'
import CourseList from './containers/CourseList'
import CourseReserve from './containers/CourseReserve'


const mapStateToProps = state => {  
  return {    
    isLogged: state.user.isLogged,
    currCourse: state.courses.currCourse,
  }
}

class Search extends React.Component{   
  constructor (props) {
    super(props)
    this.state = {
      currCourse: null,
    }
  }
  render() {
    if (!this.props.isLogged)
      return <Redirect to='/'/>;
    
    if (this.props.currCourse===null)
      return this.renderSearch()
    else
      return this.renderReserve()        
  }
  renderSearch(){
    return (
      <div>        
        <CourseFilter/>
        <CourseList />
      </div>
    )
  }
  renderReserve(){
      return (
        <CourseReserve/>
      )
  }
}
export default connect(
  mapStateToProps,
  //mapDispatchToProps
)(Search)        


// WEBPACK FOOTER //
// ./src/Search.js